export default __webpack_public_path__ + "static/media/Geral.a34495a4.png";